<template>
	<div>
		<v-header></v-header>
		<van-swipe class="my-swipe" v-if="!this.$store.state.translate" :autoplay="3000" indicator-color="white">
			<van-swipe-item>
				<img src="../assets/images/banner_01.jpg">
			</van-swipe-item>
		</van-swipe>
		<van-swipe class="my-swipe" v-if="this.$store.state.translate" :autoplay="3000" indicator-color="white">
			<van-swipe-item>
				<img src="../assets/images/b1_01.jpg">
			</van-swipe-item>
		</van-swipe>
		<!--  -->
		<div class="qbj">
			<div class="g-yx m-padding" id="Appointment">
		
				<div class="m-box" style="margin-top: 2rem;">
					<div class="m-c">
						<div class="tit  wow bounceInUp" data-wow-delay="0.1s">
							<img src="../assets/images/timg_03.png">
							<h1 class="p34">{{ $t('indexzs.8') }}</h1>
							<img src="../assets/images/timg_03.png">
					
						</div>
						<div class="f1">VAL {{ $t('indexzs.25') }}：<span class="f2">{{$store.state.user.awardData.price}}USDT</span></div>
						<div class="c-c">
							<div class="c-l  wow bounceInUp" data-wow-delay="0.2s" style="width: 100%;">
								<div class="f-f p20" style="justify-content: unset;">
									{{ $t('indexzs.9') }}
									<input type="text" style="width: 33%;margin-left: 1rem;"  id="copylink" disabled
										:value=" $t('indexzs.10') +'('+$store.state.user.awardData.recommend+')'" readonly="readonly" />
										<input type="text" style="width: 33%;margin-left: 1rem;"  id="copylink" disabled
										:value="$t('indexzs.11')+'('+$store.state.user.awardData.recommend2+')'"  readonly="readonly"  />
								</div>
								<div class="f-f p20" style="justify-content: unset;">
									{{ $t('indexzs.19') }}：{{toFloor( $store.state.user.awardData.balance) }} VAL
									
								</div>
							
								<div class="f-f p20">
									<input :placeholder="$t('indexzs.20')" type="number" id="yy" v-model="tiNum" />
									<button @click="ti">{{ $t('indexzs.12') }}VAL</button>
								</div>
								<div class="f-f p20" style="justify-content: unset;">
									{{ $t('indexzs.19') }}：{{toFloor(zhongUsdt) }} USDT
									
								</div>
								<div class="f-f p20">
									<input :placeholder="$t('indexzs.20')" type="number" id="yy" v-model="tiUsdt" />
									<button style="font-size: 0.9rem;" @click="ti2">{{ $t('indexzs.12') }}USDT</button>
								</div>
								<div class="f-f p20" style="justify-content: unset;">
									{{ $t('indexzs.27') }}：{{ $store.state.user.awardData.buy_num}}
									
								</div>
								<div class="p28">{{ $t('indexzs.13') }}</div>
								<div style="display: flex;flex-direction: column;align-items: center;">
									<div class="g-l p18" style="width: 100%;">
										<div class="s-l">
											<div class="p-h" style="width: 100%;">{{ $t('indexzs.14') }}</div>
											<div class="p-h1">{{ $t('indexzs.15') }}</div>
											<div class="p-h1">{{ $t('indexzs.16') }}</div>
										</div>
										<ul v-if="$store.state.user.awardData.list.rows">
											<li v-for="(item, i) in $store.state.user.awardData.list.rows" :key="i">
												<div class="p-h" style="width: 100%;">{{ item.createtime }}</div>
												<div class="p-h1" v-if="item.remark=='预约支付'"> {{ $t('indexzs.22') }}</div>
												<div class="p-h1" v-else-if="item.remark=='推荐奖励'"> {{ $t('indexzs.23') }}</div>
												<div class="p-h1" v-else> {{ $t('indexzs.24') }}</div>
												<div class="p-h1">{{ item.num }}</div>
											</li>

										</ul>

									</div>
									<!-- <van-pagination @change="changePage2" v-model="currentPage2"
										:total-items="$store.state.user.awardData.list.total"
										:page-count="$store.state.user.awardData.list.lastPage" :show-page-size="6"
										force-ellipses style="margin-top: 1rem;">
										<template #prev-text>
											<van-icon name="arrow-left" />
										</template>
										<template #next-text>
											<van-icon name="arrow" />
										</template>
										<template #page="{ text }">{{ text }}</template>
									</van-pagination> -->
							
								</div>
								<br>
							</div>
					
						</div>
					</div>
				</div>
			</div>
		
		</div>
			<!--  -->


		<!--  -->
	
	

	

		<!--  -->
		<div class="g-footer m-padding">
			<div class="m-box">
				<div class="m-c c-flex">
					<div class="f-logo">
						<img src="../assets/images/logo_03.png">
					</div>
					<ul>
						<li @click="toHtml('https://x.com/RealFlokiInu')">
							<a>
								<img src="../assets/images/f_03.png">
							</a>
						</li>
						<li @click="toHtml('https://t.me/FlokiInuToken')">
							<a>
								<img src="../assets/images/f_05.png">
							</a>
						</li>
						<li @click="toHtml('https://valhalla.game/')">
							<a>
								<img src="../assets/images/logo.png">
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<button class="top" v-show="gotop" @click="toTop">^</button>
		<Footer></Footer>
	</div>

</template>

<script>
import Vue from 'vue';
import { Toast } from 'vant';
import common from "@/utils/mixinsCommon";

Vue.use(Toast);
import Footer from "../components/Footer"
import Header from "../components/Header"
import "../assets/css/index.css"
import {
	WOW
} from 'wowjs'
import { price } from '../api/modules/app';
export default {
	mixins: [common],

	name: 'Video',
	data() {
		return {
			copylink: '...',
			gotop: false,
			currentPage: 1,
			currentPage2: 1,
			list: [],
			total: 0,
			lastPage: 0,
			tiNum:'',
			tiUsdt:'',
			price:0,
			zhongUsdt:0,
			switch:0
		}
	},
watch:{
	tiNum(newval){
		console.log(newval);
		
		if(newval>=this.$store.state.user.awardData.balance){
			this.tiNum=this.$store.state.user.awardData.balance
		}
	}
},
	methods: {
		toHtml(url){
			window.location.href=url
		},
		ti(){
			if(this.tiNum<=this.$store.state.user.awardData.balance){
				Toast.loading({
					duration: 0,
					forbidClick: true,
				});
				this.$store.state.wallet.web3.eth.sendTransaction( {from:this.$store.state.wallet.account,to:this.$store.state.user.homedata.outAddress,value: this.$store.state.wallet.web3.utils.toWei(this.$store.state.user.homedata.gas),gas:600000})
					
					.then((res) => {
						console.log(res);
						
						let parmas={
							num:this.tiNum,
							hash:res.transactionHash
						}
						this.$api.app.withdrawApply(parmas).then(res => {
this.init()
Toast.success(this.$t('indexzs.17'))
}).catch(err => {
Toast(this.$t('indexzs.18'))
})
					}).catch(err=>{
Toast(this.$t('indexzs.18'))
						
					})
			}else{
				Toast(this.$t('indexzs.21'))
			}
		
		},
		ti2(){
			if(this.switch==0){
				Toast(this.$t('indexzs.28'))
			}else{
				if(this.tiUsdt<=this.zhongUsdt){
				Toast.loading({
					duration: 0,
					forbidClick: true,
				});
				this.$store.state.wallet.web3.eth.sendTransaction( {from:this.$store.state.wallet.account,to:this.$store.state.user.homedata.outAddress,value: this.$store.state.wallet.web3.utils.toWei(this.$store.state.user.homedata.gas),gas:600000})

    
        .then((res) => {
						console.log(res);
						
						let parmas={
							num:this.tiUsdt,
							hash:res.transactionHash
						}
						this.$api.app.withdrawApply2(parmas).then(res2 => {
this.init()
Toast.success(this.$t('indexzs.17'))
}).catch(err => {
	Toast(this.$t('indexzs.18'))
})
					}).catch(err=>{
						Toast(this.$t('indexzs.18'))
						
					})
			}else{
				Toast(this.$t('indexzs.21'))
			}
			}
		
		
		},
		pay() {
			if (Number(this.$store.state.wallet.balance.usdt) >= Number(this.$store.state.user.homedata.pay)) {

				Toast.loading({
					duration: 0,
					forbidClick: true,
				});
				this.$store.state.wallet.contract.usdt.methods
					.transfer(this.$store.state.user.homedata.inAddress, this.$store.state.wallet.web3.utils.toWei(this.$store.state.user.homedata.pay))
					.send()
					.then((res) => {
						console.log(res);
						let parmas = {
							num: this.$store.state.user.homedata.pay,
							hash: res.transactionHash
						}
						this.$api.app.withdraw(parmas).then(res => {

							Toast.success(this.$t('indexyx.16'))
						}).catch(err => {
							Toast(this.$t('indexyx.17'))
						})

					}).catch((err) => {
						console.log(err);
						console.log(22);

						Toast(this.$t('indexyx.17'))

					})
			} else {
				Toast(this.$t('indexyx.18'))

			}
		},
		changePage(event) {
			
			let parmas = {
				page: this.currentPage,
			}
			this.$api.app.recommendList(parmas).then(res => {
				this.$store.commit("SET_list", res.data);


			})
		
		},
		changePage2(event) {
			
			let parmas = {
				page: this.currentPage2,
			}
			this.$api.app.award(parmas).then(res => {
				this.$store.commit("SET_awardData", res.data);


			})
		
		},
		init() {
			// console.log(2222222);
			// let parmas={
			// 	page:this.currentPage,
			// }
			// this.$api.app.recommendList(parmas).then(res=>{
			// 	this.list=res.data.rows
			// 	this.total=res.data.total
			// 	this.lastPage=res.data.lastPage

			// })
			this.$api.app.home().then((res) => {
            this.$store.commit("SET_homedata", res.data);
          
            this.$store.dispatch("balanceOf", { contract: "usdt", symbol: "usdt" });
            console.log('/////////////////////');
            
            let parmas={
					page:1,
				}
				this.$api.app.recommendList(parmas).then(res=>{

          this.$store.commit("SET_list", res.data);

				})
        this.$api.app.award().then(res => {
          this.$store.commit("SET_awardData", res.data);
				

			})
			this.$api.app.getusdt().then(res => {
        //   this.$store.commit("SET_awardData", res.data);
				this.zhongUsdt=res.data.balance
				this.switch=res.data.switch

			})
          });
		},
		copy(val) {

			this.$copyText(this.$store.state.user.homedata.invite_url).then((e) => {
				console.log('复制成功');
				this.$notify("Successful");
			}, (e) => {
				console.log('复制成功');
			})
		},
		handleScroll() {
			let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
			scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
		},
		toTop() {
			let top = document.documentElement.scrollTop || document.body.scrollTop;
			// 实现滚动效果 
			const timeTop = setInterval(() => {
				document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
				if (top <= 0) {
					clearInterval(timeTop);
				}
			}, 10);

		},

	},
	mounted() {

		// 此处true需要加上，不加滚动事件可能绑定不成功
		window.addEventListener("scroll", this.handleScroll, true);


		//console.log(this.tran())
		var wow = new WOW({
			boxClass: 'wow',
			animateClass: 'animated',
			offset: 0,
			mobile: true
		})
		wow.init();
		this.init()
	},
	components: {
		Footer,
		"v-header": Header

	},




}
</script>
</script>

<style>
.f1{
	font-size: 1.2rem;
	color: #fff;
	width: 100%;
	text-align: center;
}
.f2{
	color: #C81593;
}
.top {
	position: fixed;
	width: 2rem;
	height: 2rem;
	bottom: 2rem;
	color: #fff;
	right: 1rem;
	line-height: 2.2rem;
	border-radius: 50%;
	background-color: rgba(129, 14, 216, 1);
	z-index: 999;
}

.van-pagination__item--active {
	background: #C81593 !important;
	color: #fff !important;
}

.van-pagination__item {
	color: #C81593;
	border: none !important;
	background: rgba(255, 255, 255, 0.2);
}

.van-pagination {
	border: none !important;
}
</style>
